import { render, staticRenderFns } from "./selectTenant.vue?vue&type=template&id=ed86aa70&"
import script from "./selectTenant.vue?vue&type=script&lang=ts&"
export * from "./selectTenant.vue?vue&type=script&lang=ts&"
import style0 from "./selectTenant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports